import React from 'react';
import BaseIcon from '@material-ui/icons/RemoveCircleSharp';

const RemoveCircleSharp = (props) => <BaseIcon {...props} />;

export default RemoveCircleSharp;
